// Types
import type { AppModule, AppExt, Model } from 'modapp';
import type Auth from 'modules/common/auth/Auth';
import type { UserModel } from 'types/Api';
export type RedirectElearnerModules = {
	auth: Auth;
} & Record<string, AppModule>;

/**
 * RedirectElearner adds a post login handler that redirects the user to the
 * simplified e-learning page if they are flagged to be redirected.
 */
class RedirectElearner {
	private module!: RedirectElearnerModules & { self: RedirectElearner };

	constructor(public app: AppExt, _params: any) {
		this.app.require<RedirectElearnerModules>([
			'auth',
		], (module) => this.init(module));
	}

	private init(module: RedirectElearnerModules) {
		this.module = Object.assign({ self: this }, module);

		this.module.auth.addPostLoginHandler({
			id: 'redirectElearner',
			sortOrder: 10,
			callback: async (_user: UserModel, roles: Model<Record<string, true>>) => {
				if (roles.participant_elearn_redirect) {
					window.location?.replace('/learn');
				}
			},
		});
	}

	dispose() {
		this.module.auth.removePostLoginHandler('redirectElearner');
	}
}

export default RedirectElearner;
